<template>
  <!-- 
    name: 覃刚
    function: 登录页面
    date: 2021-03-01 
 -->
 <div class="loginPageClass">
  <div class="loginBox" v-track.login="{userInfo}">
    <div class="login-slider">
      <div class="login-slider-inner">
        <a-carousel dot-position="bottom" :autoplay="true">
          <div v-for="(item,index) in banner" :key="index">
            <div class="banner-img" :style='{backgroundImage:`url(${item.img})`}' />
            <div class="banner-title">{{ item.title }}</div>
          </div>
        </a-carousel>
      </div>
    </div>
    <div class="login-container">
        <img src="../../assets/images/logo_nhf.svg" alt="NHF PRO" class="imgClass" />
      <!-- <a-form  id="components-form-demo-normal-login" :form="form" class="login-form" >
        <a-form-item>
          <a-input size="large" @pressEnter="loginIn" v-decorator="[ 'account', { rules: [{ required: true, message: '账户不能为空' }] }, ]" placeholder="账户" >
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input-password size="large" v-decorator="[ 'password', { rules: [{ required: true, message: '密码不能为空' }] }, ]" @pressEnter="loginIn" placeholder="密码" type="password" >
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
          </a-input-password>
        </a-form-item>
        <a-form-item class="button-bar">
          <a-space direction="vertical" style="width:100%" >
            <a-button size="large" block type="primary" @click="loginIn" class="login-form-button">登录</a-button>
            <a-button size="large" block type="link" ghost><a :href="url">使用OA账户登录</a></a-button>
          </a-space>
        </a-form-item>
      </a-form> -->
      <div style="text-align: center;color: #333;">
        <h3 style="font-size: 24px;font-weight: bold;margin-bottom: 0">扫码登录</h3>
        <p style="margin-bottom: 0;">请使用飞书移动端扫描二维码</p>
      </div>
      <div id='QRCode'></div>
      
      <div class="button-bar">
        <a-space direction="vertical" style="width:100%" >
          <p>没有飞书账户？使用<a :href="url">OA账户登录</a></p>
        </a-space>
      </div>
    </div>
    <!-- <div class="footBox"><button @click="loginIn">登录</button></div> -->
  </div>
 </div>
</template>
<script>
// import sha1 from 'sha1';
  import bg1 from '../../assets/login/01.jpg'
  // import bg2 from '../../assets/login/02.jpg'
  // import bg3 from '../../assets/login/03.jpg'
  // import bg4 from '../../assets/login/04.jpg'
  // import bg5 from '../../assets/login/05.jpg'
  // import bg6 from '../../assets/login/06.jpg'

import {instance} from '../../Utils/axios'
import {baseUrl} from '@/Utils/url.js'
// import axios from "axios"
// import loginLogo from '@/assets/images/login-logo.png'
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 },
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 },
};
export default {
  name: 'login',
  data(){
    return {
      userInfo: {},
      images:[bg1],
      checkNick: false,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      loginLogo: require('@/assets/images/login-logo.png'),
      formData: {},
      url: '',
      banner:[
        {
          img:require('@/assets/login/01.jpg'),
          title:''
        }
      ],
      QRLoginObj: null,
      CLIENT_ID: '',
      callBackUrl: '',
      state: ''
    }
  },
  created(){
    let time = localStorage.getItem('loginTime')
    let refreshToken = localStorage.getItem('refreshToken')
    if(time && refreshToken){
      if((new Date().getTime() - time) < 18000 * 1000){
        this.$router.push('/factory?name=选择工厂')
      }
      this.userInfo = this.setUserInfo(JSON.parse(window.localStorage.getItem('userInfo')))
    }
    let src = window.location.href;
    if(src.split('/#/').length){
      let clientUrl = encodeURIComponent(src.split('/#/')[0] + '/#/checkLogin')
      let localUrl = instance.defaults.baseURL ? instance.defaults.baseURL : baseUrl
      this.url = `${localUrl}iot-auth/oauth/render/newhope?clientUrl=${clientUrl}`
    }
  },
  mounted(){
    this.form.setFieldsValue({
      account:'',
      password:''
    })
    if(!this.CLIENT_ID){
      this.getInformation()
    }
  },
  computed:{
    loginStyle () {
      return { backgroundImage: `url(${this.images[Math.floor(Math.random() * this.images.length)]})` }
    }
  },
  methods:{
    setUserInfo(data){
      let { userId,userName,email, code: userNo, userType, phoneNumber, clientId, } = data || {}
      return {userName, userId, email, userNo, userType, phoneNumber, clientId,}
    },
    setInit(CLIENT_ID, REDIRECT_URI, state) {
      this.QRLoginObj = window.QRLogin({
        id: "QRCode",
        goto: `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&state=${state}`,
        width: "300",
        height: "300",
        style: "border: none"
      });
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', this.handleMessage, false);
      } 
      else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', this.handleMessage);
      }
    },
    refreshQRcode(){
      
    },
    getInformation(){
      let clientUrl = window.location.href.split('/#/')[0]
      this.$http.get('/iot-auth/oauth/getAuthServerInfo/feishu',{params: {clientUrl}}).then(res => {
        let {success,data} = res || {}
        if(success){
          let {callBackUrl,appId,state} = data || {}
          this.CLIENT_ID = appId
          this.callBackUrl = callBackUrl
          this.state = state
          this.setInit(appId,callBackUrl,state)
          this.apiAuthNew(data)
        }
      })
    },
    handleMessage(event) {        
      let origin = event.origin;
      // let REDIRECT_URI = window.location.href.split('/#/')[0]
      if( this.QRLoginObj.matchOrigin(origin) ) {           
        let code = event.data;
        let goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${this.CLIENT_ID}&redirect_uri=${this.callBackUrl}&tmp_code=${code}&response_type=code&state=${this.state}`
        window.location.href = `${goto}`
      }else{
        // 
      }
    },
    loginIn() {
      window.localStorage.setItem('accessToken','');
      window.localStorage.setItem('loginTime',0)
      this.form.validateFields((err, params) => {
        this.$http.post('/iot-auth/token',`account=${params.account}&grantType=password&password=${params.password}&refreshToken=&tenantId=000000`).then(res => {
          let {success,msg} = res;
          if(success){
            let { accessToken,refreshToken,userId,userName,email, code: userNo, userType, phoneNumber, clientId, }  = res.data || {};
            this.$track.sendTrack('login',{
              clickList: this.clickList,
              userInfo: { userName, userId, email, userNo, userType, phoneNumber, clientId, }
            })
            window.localStorage.setItem('userInfo',res.data);
            window.localStorage.setItem('accessToken',accessToken);
            window.localStorage.setItem('userName',userName);
            window.localStorage.setItem('staffId',userId);
            window.localStorage.setItem('loginTime',new Date().getTime())
            window.localStorage.setItem('refreshToken',refreshToken)
            window.localStorage.removeItem('blenCurrent')
            window.localStorage.removeItem('blenSize')
            window.localStorage.removeItem('compoundCurrent')
            window.localStorage.removeItem('compoundSize')
            let targetUrl = window.localStorage.getItem('targetUrl')
            if(targetUrl && targetUrl !== '/login' && targetUrl !== '/checkLogin'){
              let factoryId = window.localStorage.getItem('factoryId')
              let factoryName = window.localStorage.getItem('factoryName')
              let factory = window.localStorage.getItem('factory')
              if(factoryId&&factoryName&&factory){
                this.$router.push(targetUrl)
              }else{
                this.$router.push('/factory?name=工厂选择')
              }
            }else{
              this.$router.push('/factory?name=工厂选择')
            }
          }else{
            msg && this.$message.error(msg)
          }
        });
      })
    },
    apiAuthNew(data){
      if (!window.h5sdk) {
        return;
      }
      window.open(`https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${data.callBackUrl}&app_id=${data.appId}&state=${data.state}`)
      // window.h5sdk.ready(() => {
      //   window.open(`https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${data.callBackUrl}&app_id=${data.appId}&state=${data.state}`)
        // window.tt.requestAuthCode({
        //   appId: this.CLIENT_ID,
        //   success: (info) => {
        //     window.open(`https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${data.callBackUrl}&app_id=${this.CLIENT_ID}&state=${data.state}`)
        //     // let goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${this.CLIENT_ID}&redirect_uri=${data.callBackUrl}&tmp_code=${info.code}&response_type=code&state=${data.state}`
        //     // window.location.href = `${goto}`
        //   },
        //   fail: (error) => {
        //     console.error(error)
        //   }
        // });
        // window.tt.getUserInfo((us) => {
        //   console.log('us',us)
        // })
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
.login-slider ::v-deep .slick-slide {
  text-align: center;
  height: 600px;
  line-height: 600px;
  overflow: hidden;
}

.login-slider ::v-deep .slick-slide h3 {
  color: #fff;
}

.banner{
  &-img{
    width:100%;
    height: 630px;
    background-size: cover;
    background-position: center center;
    background-size: cover;
  }
  &-title{
    position: absolute;
    left:0;right:0;
    bottom: 0;
    z-index: 10;
  }
}
.login-slider{
  height: 100%;
  height: 100%;
  width:500px;
  &-inner{
    width: 100%;
    height: 100%;
  }
}

.login-container{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width:500px;
  padding:0 70px;
}
.loginBox{
  display: flex;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 20px 40px rgba($color: #000000, $alpha: .1);
  overflow: hidden;
  border-radius: 10px;
  margin-top:-80px;
  .imgClass {
    // 中文图标
    height: 34px;
    margin-bottom: 20px;
    // 英文图标
    // height: 28px;
    // margin-bottom: 40px;
  }
  .titleBox {
    text-align: center;
    margin-bottom:25px;
   
    .loginTitle{
      font-weight: bold;
      font-size: 14px;
      color: #1998f7;
    }
  }
}
.loginPageClass{
    height: 100vh;
    background-color: #f1f2f6;
    background-size: 1250px;
    background-repeat:repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    margin:0 auto;
    width:100%;
}
@keyframes sliderUp{
  from{
    transform: translateY(50%);
  }
  to{
    transform: translateY(0);
  }
}


</style>
<style lang="scss">
.loginBox .login-form{
  width: 100%;
}
.loginBox .ant-input-lg{
  font-size: 14px !important;
  height: 40px !important;
}
.button-bar{
  button{
    font-size: 14px !important;
    height: 40px;
    a{
      color: #1890ff !important;
    }
  }
}

</style>